import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useAppTheme } from "../../../useAppTheme";
import { useDevice } from "../../../useDevice";
import Box from "../../Box";
import { getStudySessionBottomBarHeight } from "../constants";

type Props = {
	children: React.ReactNode;
	isSummativeTest?: boolean;
	inReviewMode?: boolean;
};

const BottomNavigationSession = (props: Props) => {
	const { children, isSummativeTest, inReviewMode } = props;
	const theme = useAppTheme();
	const { isMobile } = useDevice();
	const insets = useSafeAreaInsets();

	return (
		<Box
			style={{
				borderTopWidth: 1,
				borderTopColor: theme.colors.surfaceVariant,
				height: getStudySessionBottomBarHeight({
					safeAreaBottom: insets.bottom,
					isMobile,
					isSummativeTest,
					inReviewMode,
				}),
				flexDirection: "row",
				alignItems: isMobile ? "flex-start" : "center",
				paddingHorizontal: isMobile ? 16 : 24,
				paddingTop: isMobile ? 16 : 0,
				backgroundColor: theme.colors.surface,
			}}
		>
			{children}
		</Box>
	);
};

export default BottomNavigationSession;
